import { type PartialDeep } from 'type-fest';

import {
  type PropertiesConfigInputVisualEffectModel,
  type VisibilityAccessRoleRef,
} from '@blaze-shared/elements-domain';
import { mergeDefinedIntoArray } from '@blaze-shared/shared-util';

import { extractElementContentActionWorkflowRef } from '../../canvas-elements/element-model/props-extractor';
import { PropsExtractor } from '../__base/props-extractor';

export class SchedulerPropsExtractor extends PropsExtractor<'scheduler'> {
  override getVisualEffect: () => PartialDeep<PropertiesConfigInputVisualEffectModel> | undefined =
    () => this.props?.style?.background?.visualEffect;

  override getVisibilityAccessRolesRefs(): VisibilityAccessRoleRef[] {
    return mergeDefinedIntoArray(
      ...super.getVisibilityAccessRolesRefs(),
      ...extractElementContentActionWorkflowRef(this.props?.content?.action),
    );
  }
}
